import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppFacade } from '@app/app.facade';

@Pipe({
  name: 'airportName',
  standalone: false
})
export class AirportNamePipe implements PipeTransform {

  constructor(private facade: AppFacade) { }

  transform(code: string, ...args: string[]): Observable<string> {
    return this.facade.airportsEntities$
      .pipe(
        map(airlines => airlines[code]?.name)
      );
  }
}
